// src/pages/HomePage/index.jsx
import React from "react";
import { Box } from "@mui/material";

import HeroSection from "./sections/HeroSection";
import FeaturesSection from "./sections/FeaturesSection";
import StatsSection from "./sections/StatsSection";
import WorkflowSection from "./sections/WorkflowSection";

const HomePage = () => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        position: "relative",
        m: 0,
        p: 0,
        width: "100%",
      }}
    >
      <HeroSection />
      <FeaturesSection />
      <StatsSection />
      <WorkflowSection />
    </Box>
  );
};

export default HomePage;
